import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const TABS = [
  { label: 'Orders', path: '/performance' },
  { label: 'Clicks', path: '/performance/click-to-order' },
  { label: 'Matches & Impressions', path: '/performance/matches-impressions' },
  { label: 'Click balancing', path: '/performance/click-balancing' },
  { label: 'Order Share', path: '/performance/order-share' },
];

const PerformanceTabBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const activeIndex = TABS.findIndex((t) => t.path === location.pathname);
  const value = activeIndex >= 0 ? activeIndex : 0;

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs
        value={value}
        aria-label="Performance views"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {TABS.map((tab, i) => (
          <Tab key={tab.path} label={tab.label} onClick={() => navigate(tab.path)} id={`perf-tab-${i}`} />
        ))}
      </Tabs>
    </Box>
  );
};

export default PerformanceTabBar;
